module.exports = __webpack_public_path__ + "img/video-thumb-10-fr.7d5c724f.png";